/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions*/

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ListEnquiryButtons from 'components/ListEnquiryButtons';
import { FieldArray, Form, Formik } from "formik";
import Colors from "constants/Colors";
import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import { Layout, Text } from "components";
import { Col, Row } from "components/Grid";
import Badge from 'components/Badge'
import Icon from "components/Icon";
import Loader from "components/Loader";
import { FitinsurAPI, MessageCenter, CacheManager } from "utils";
import {
  TableHeader,
  TableCollum,
  Content,
  InlineLabel,
  LoadContainer,
  TableHead,
  TableRow,
  TableBody,
  Table,
  DialogIcon,
  ItemProduct,
  TitleProducts,
  ContainerProducts,
  ButtonContainer
} from "./styles";
import { Button } from "components/index";
import {
  LoaderContext
} from '@fitinsur/contexts';
import { useGetQuery, useGetStatusOptions } from '@fitinsur/services/QuestionnairesService';
import { ResponsiveTable, Label, ListHeader } from '@fitinsur/components/';
import { useGetQuoteList } from "services/OperationService";

import ContentCard from 'components/ContentCard/index';
import { NotesModal, DialogComponent } from '@fitinsur/components';
import HasPermission from 'components/HasPermission/index';

export default function List({ permissions }) {
  const authContext = useContext(GlobalAuthContext);
  const region = authContext.region === 'en-GB' ? 'en' : authContext.region;

  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();
  const location = useLocation();
  const formik = useRef();
  const [sortBy, setSortBy] = useState({
    key: null,
    direction: null,
  });
  const [headerBroker, setHeaderBroker] = useState([]);
  const cache = new CacheManager();
  const [message, setMessage] = useState([null]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [persons, setPersons] = useState([]);
  const [personAdditionalInfoSelected, setPersonAdditionalInfoSelected] = useState([]);
  const [listData, setListData] = useState([]);
  const [slaSituation, setSlaSituation] = useState([]);
  const [headerStatus, setHeaderStatus] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [idOperationSelected, setIdOperationSelected] = useState(null);
  const [isMediationFinished, setIsMediationFinished] = useState(false);
  const [modalities, setModalities] = useState([]);
  const [notesModal, setNotesModal] = useState(false);
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });
  const [paginationControls, setPaginationControls] = useState({
    "currentPage": 1,
    "numberMaxRecords": null,
    "total": null,
    "totalPages": null,
    "numberRecords": null
  });
  const [products, setProducts] = useState(
    [
      {
        label: "NENHUM PRODUTO DISPONÍVEL",
        value: ""
      }
    ]
  );

  const initialFilterData = [
    { label: "NÚMERO", orderKey: 'orderIdOperation', key: 'idOperation', type: 'text' },
    { label: "DATA DE CRIAÇÃO", orderKey: 'orderOperationDate', key: 'operationDate', type: 'date' },
    { label: "USUÁRIO", orderKey: 'orderUser', key: 'userName', type: 'text' },
    { label: "CORRETORA", orderKey: 'orderBroker', key: 'nmBroker', type: 'list' },
    { label: "TIPO DE SEGURO", orderKey: 'orderTypeInsurance', key: 'typeInsurance', type: 'list' },
    { label: "PRODUTO", orderKey: 'orderProductName', key: 'productName', type: 'list' },
    { label: "MODALIDADE", orderKey: 'orderModality', key: 'modality', type: 'list' },
    // { label: "TOMADOR", orderKey: 'orderBorrower', key: 'borrower', type: 'text' },
    { label: "SEGURADO", orderKey: 'orderInsured', key: 'insured', type: 'text' },
    { label: "IS", orderKey: 'orderIs', key: 'operationMaxLimClaim', type: 'range' },
    { label: "SITUAÇÃO", orderKey: 'orderStatus', key: 'status', type: 'list' },
    { label: "SLA", orderKey: 'orderSla', key: 'sla', type: 'list' },
  ];

  const {
    data: getQuoteListData,
    loading: getQuoteListLoading,
    error: getQuoteListError,
    status: getQuoteListStatus,
    request: getQuoteListRequest,
  } = useGetQuoteList();

  const {
    request: useGetQueryRequest,
  } = useGetQuery();

  const {
    request: getStatusOptionsRequest,
  } = useGetStatusOptions();

  const initialValues = {
    filter: {
      number: "",
      firstName: "",
      fullName: "",
      hierarchy: "",
      parent: "",
      holding: "",
      personStatus: "",
    },
  };

  const columns = [
    {
      title: "NÚMERO",
      key: "idOperation",
      sortKey: 'orderIdOperation',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "DATA DE CRIAÇÃO",
      key: "operationDate",
      sortKey: 'orderOperationDate',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        return <>
          <Label wordWrap fontSize={13} color={handleColorLabel(listItem)}>
            {new Date(listItem.operationDate).toLocaleDateString('pt-br')}
          </Label>
        </>
      },
    },
    {
      title: "USUÁRIO",
      key: "userName",
      sortKey: 'orderUser',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "CORRETORA",
      key: "nmBroker",
      sortKey: "orderBroker",
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "TIPO DE SEGURO",
      key: "typeInsurance",
      sortKey: 'orderTypeInsurance',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "PRODUTO",
      key: "productName",
      sortKey: 'orderProductName',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "MODALIDADE",
      key: "modality",
      sortKey: 'orderModality',
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        return (
          <Label wordWrap fontSize={13} color={handleColorLabel(listItem)}>
            {listItem?.modality || listItem?.modalityPrivateSector}
          </Label>
        )
      },
    },
    // {
    //   title: "TOMADOR",
    //   key: "borrower",
    //   sortKey: 'orderBorrower',
    //   minWidth: 16,
    //   maxWidth: 16,
    //   color: (item) => handleColorLabel(item)
    // },
    {
      title: "SEGURADO",
      key: "insured",
      sortKey: 'orderInsured',
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "IMPORTÂNCIA SEGURADA",
      key: "operationMaxLimClaim",
      sortKey: 'orderIs',
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item),
    },
    {
      title: "SITUAÇÃO",
      key: "status",
      minWidth: 15,
      maxWidth: 15,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        return <>
          <Label wordWrap fontSize={13} color={handleColorLabel(listItem)}>
            {(([4].includes(listItem.idDomainStatusOper) && listItem?.additionalInformation) || listItem.mediationFinished) &&
              <Icon
                name={'info'}
                title="Informações Adicionais"
                style={{ margin: 0, marginBottom: -5 }}
                className="mr-1"
                onClick={() => {
                  setIdOperationSelected(listItem.idOperation)
                  setNotesModal(true)
                  setIsMediationFinished(listItem.mediationFinished)
                }}
              />
            }
            {listItem?.metadata?.integrationErrors?.length > 0 && 
              listItem.metadata.integrationErrors.some((error) => error.showInPopup) &&
              listItem.idDomainStatusOper === 10 &&
              (listItem?.isRenewal || listItem?.metadata?.endorsementReferenceNumber) &&            
              <Icon
                name='exclamation' 
                style={{ margin: 0, marginBottom: -5 }}
                onClick={() => createModalIntegrationErrors(listItem.metadata.integrationErrors)}
              />
            }
            {listItem['status'] || '-'}
          </Label>
        </>
      },
    },
    {
      title: "SLA",
      key: "sla",
      sortKey: 'orderSla',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        return (
          <Label wordWrap fontSize={13}>
            {Badge({
              sla: {
                today: new Date(),
                operationDate: listItem.operationDate,
                quotationExpirePeriod: listItem.quotationExpirePeriod / (60 * 24),
                slaCompletionDate: listItem?.metadata?.slaCompletionDate || null
              }
            })}
          </Label>
        )
      },
    },
    {
      title: "AÇÕES",
      key: "action",
      minWidth: 8,
      maxWidth: 8,
      paddingRight: 5,
      component: (listItem) => <ListEnquiryButtons
        editRoute={checkOperationRoute}
        listItem={listItem}
        idOperation={listItem.idOperation}
        permissions={permissions || {}}
        authContextToken={authContext?.token}
        createCopy={handleCreateEnquiryCopy}
        toDocument={() => history.push(`/broking/document-management/${listItem.idOperation}`)}
      />
    },
  ];

  useEffect(() => {
    if (!notesModal) setIdOperationSelected(null);
  }, [notesModal])

  const storedFilterOption = localStorage.getItem('enquiry-filter-sompo');
  const storedStringFilterOption = localStorage.getItem('str-enquiry-filter-sompo');
  let quotesUrl = '/list' + (storedStringFilterOption ? '?' + storedStringFilterOption : '');

  const [filterData, setFilterData] = useState(storedFilterOption ? JSON.parse(storedFilterOption) : initialFilterData);

  const requestBrokerList = async () => {
    const { data } = await useGetQueryRequest({
      id: 'fitQueryPersonBroker',
      params: {
        id: "fitQueryPersonBroker",
        queryTail: true,
        personName: ''
      }
    });

    try {
      if (data.ret_code !== 200) return;

      const persons = data.ret_value.map(person => ({
        ...person,
        label: person.personName,
        value: person.id
      }));

      setBrokerList(persons);
    } catch (err) {
      console.log("err fitQueryPersonBroker", err)
    };
  };

  const requestStatusOptions = async () => {
    const { data } = await getStatusOptionsRequest();

    const idDomainsStatusMapped = [1, 7, 4, 10, 8, 5, 2, 16, 19, 20, 406];

    const statusCreditAnalysis = data.value.filter((f) =>
      idDomainsStatusMapped.includes(f.idDomainStatus)
    );

    const formattedStatus = statusCreditAnalysis.map(
      (status) => ({
        ...status,
        label: status.statusDescription,
        value: status.idDomainStatusList?.join(',') || status.idDomainStatus,
      })
    );

    setOptionsStatus(formattedStatus);
  };

  const handleColorLabel = (item) => {
    if (item.isRejected) return Colors.GRAY[3];
    else if (item.isApproved) return Colors.GRAY[0];
    else if (item.idDomainStatusOper === 4 && item?.additionalInformation) return Colors.RED;
    else if (item.idDomainStatusOper === 10 && (item?.isRenewal || item?.metadata?.endorsementReferenceNumber)) return Colors.RED;
    else if (item.mediationFinished) return Colors.TERTIARY;
    else return null;
  }

  const requestStatusList = () => {
    fitinsur.requestStatusHeader()
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        const mappedOpt = res.ret_value.map(x => {
          return { label: x.description, value: x.id }
        })

        setHeaderStatus(mappedOpt);
      })
  }

  const requestSlaSituationList = () => {
    setSlaSituation([
      { label: 'Cinza', value: 'gray' },
      { label: 'Verde', value: 'green' },
      { label: 'Amarelo', value: 'yellow' },
      { label: 'Vermelho', value: 'red' },
    ])
  }

  async function requestProductsList() {
    fitinsur.requestProductsList()
      .then(x => x.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }
        const options = response.ret_value
          .map(product => ({
            label: product.PRODUCT_NAME,
            value: product.ID_PRODUCT
          }))

        setProducts(options);
      })
      .catch(error => console.log(error));
  }

  const requestBrokerHeaderList = () => {
    fitinsur.requestBrokerHeader()
      .then(data => data.json())
      .then(response => {
        if (response.ret_code === 200) {
          const mappedOpt = response.ret_value.map(data => ({ label: data.nmPersonBroker, value: data.ID_PERSON || data.idPersonUser }));
          setHeaderBroker(mappedOpt);
        } else {
          mc.error("An error happened, please try again.");
        }
      })
  }


  function handleSortList(key, direction) {
        if (!key || key === 'action' || key === 'status') return;
    let sort = { [key]: direction };
        setSortBy(sort);
    let e = paginationControls;
    e.currentPage = 1;
    setPaginationControls(e);


    getQuoteListRequest(null, {
      idBrokerQuestion: 3386,
      additionalInformationQst: 1812,
      mediationFinishedQst: 1427,
      typeInsuranceQst: 3400,
      idQuestionBorrower: 1519,
      idQuestionInsured: 3373,
      idModalityQuestion: 3403,
      idModalityQuestionPrivate: 1552,
      control: {
        currentPage: 1
      },
      ...sort,
      ...(filterData
        .filter(v => v.value)
        .reduce((a, b) => {
          a[b.key] = b.value;
          return a
        }, {}))
    });
  }

  const handleFilter = (resetFilter) => {
    quotesUrl = '/list' + (localStorage.getItem('str-enquiry-filter-sompo') ? '?' + localStorage.getItem('str-enquiry-filter-sompo') : '')
    let e = paginationControls;
    e.currentPage = 1;
    setPaginationControls(e);

    const refFilterData = resetFilter ? initialFilterData : filterData;

    const filteredData = refFilterData.filter((filter) => {

      const isEmptyDate = filter
                          && filter.value
                          && filter.type === "date"
                          && filter.value.every((dateVal) => !dateVal)

     
      return !isEmptyDate

    })

    console.log("filters", filteredData)

    getQuoteListRequest(null, {
      idBrokerQuestion: 3386,
      additionalInformationQst: 1812,
      mediationFinishedQst: 1427,
      typeInsuranceQst: 3400,
      idQuestionBorrower: 1519,
      idQuestionInsured: 3373,
      idModalityQuestion: 3403,
      idModalityQuestionPrivate: 1552,
      control: {
        currentPage: 1
      },
      ...sortBy,
      ...(filteredData
        .filter(v => v.value)
        .reduce((a, b) => {
          a[b.key] = b.value;
          return a
        }, {}))
    });

    if (resetFilter) {
      localStorage.removeItem('str-enquiry-filter-sompo')
      localStorage.removeItem('enquiry-filter-sompo')
      history.push(`/list`)
    } else {
      history.push(`${quotesUrl}`)
    }
  };

  const handleCreateEnquiryCopy = async (idProduct, idOperation) => {
    history.push(`create-enquiry/${idProduct}?refOperation=${idOperation}`)
  };

  const exportList = async () => {
    const exportName = 'texel-export-list-report';
    let exportList = sessionStorage.getItem(exportName);
    let list = [];
    if (exportList) list = JSON.parse(sessionStorage.getItem(exportName))
    let verify = list.length > 0 ? list.filter(item => item.nameList == 'relatório de cotações') : false;
    if (!verify || verify.length == 0) {
      updateIsLoadingStatus(true);
      setTimeout(() => updateIsLoadingStatus(false), 1000);

      const params = {
        idBrokerQuestion: 3386,
        additionalInformationQst: 1812,
        mediationFinishedQst: 1427,
        typeInsuranceQst: 3400,
        idQuestionBorrower: 1519,
        idQuestionInsured: 3373,
        idModalityQuestion: 3403,
        idModalityQuestionPrivate: 1552,
        control: {
          currentPage: 1
        },
        brokerColumn: true,
        extraColumns: 'sompo',
        ...(filterData
          .filter(v => v.value)
          .reduce((a, b) => {
            a[b.key] = b.value;
            return a
          }, {}))
      };

      const urlParams = new URLSearchParams(params).toString();

      const url = `?${urlParams}`;

      fitinsur.setAuthToken(authContext.token);
      fitinsur.setAuthToken(authContext.token);
      const document = await fitinsur.exportQuotes(url).then(x => x.json());
      updateIsLoadingStatus(true);
      setTimeout(() => updateIsLoadingStatus(false), 1000);
      if (document.idDocument) {
        list.push({ idDocument: document.idDocument, processing: true, nameList: 'relatório de cotações' });
        sessionStorage.setItem(exportName, JSON.stringify(list));
      }
    } else {
      mc.error("Por favor, aguarde o donwload do relatório de cotações ser finalizado.");
    }
  };

  function setNextPage(paginationControls) {
    let e = paginationControls;
    e.currentPage++;
    setPaginationControls(e);

    getQuoteListRequest(null, {
      idBrokerQuestion: 3386,
      additionalInformationQst: 1812,
      mediationFinishedQst: 1427,
      typeInsuranceQst: 3400,
      idQuestionBorrower: 1519,
      idQuestionInsured: 3373,
      idModalityQuestion: 3403,
      idModalityQuestionPrivate: 1552,
      requestPage: e.currentPage,
      control: {
        currentPage: e.currentPage
      },
      ...sortBy,
      ...(filterData
        .filter(v => v.value)
        .reduce((a, b) => {
          a[b.key] = b.value;
          return a
        }, {}))
    });
  }

  useEffect(() => {
    if (location.search) {
    } else {
      const queryString = localStorage.getItem('str-management-filter-meridian') || ""
      const filterQueryString = `?${queryString}`;
    }
  }, []);


  const checkOperationRoute = (idOperation, idProduct, idDomainStatusDoc) => {
    fitinsur.setAuthToken(authContext.token);
    updateIsLoadingStatus(true);

    fitinsur.requestPolicyNavigation(idOperation).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      const {
        idOperation: nextStepIdOperation,
        idProduct: nextStepIdProduct,
        idDomain
      } = res?.ret_value || {};
      
      const alternativeRoute = (nextStepIdOperation && nextStepIdProduct && [254, 398, 400].includes(idDomain) ?
        `/edit-enquiry/${nextStepIdProduct}/${nextStepIdOperation}` :
        `/edit-enquiry/${idProduct}/${idOperation}`
      );

      let route = res.ret_value.route || alternativeRoute;
      if (route) {
        updateIsLoadingStatus(false);
        history.push({ pathname: route, state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { status: idDomainStatusDoc, idProduct: idProduct } })
      } else {
        mc.error('NAVIGATION NOT DEFINED');
        updateIsLoadingStatus(false);
      }
    }).catch(() => updateIsLoadingStatus(false));
  }

  useEffect(() => {
    getQuoteListRequest(null, {
      idBrokerQuestion: 3386,
      additionalInformationQst: 1812,
      mediationFinishedQst: 1427,
      typeInsuranceQst: 3400,
      idQuestionBorrower: 1519,
      idQuestionInsured: 3373,
      idModalityQuestion: 3403,
      idModalityQuestionPrivate: 1552,
      requestPage: currentPage,
      ...(filterData
        .filter(v => v.value)
        .reduce((a, b) => {
          a[b.key] = b.value;
          return a
        }, {}))
    });

    updateIsLoadingStatus(false);

    fitinsur.setAuthToken(authContext.token);
    requestBrokerList();
    requestProductsList();
    requestStatusList();
    requestSlaSituationList();
    requestBrokerHeaderList();
    requestStatusOptions();

    cache.getMessage("NO_ITEMS_LIST", region, "355", authContext.token).then(msg => setMessage(msg)).catch(err => console.log("error", err));
  }, []);

  useEffect(() => {
    if (getQuoteListStatus === 200) {
            if (getQuoteListData?.pagination_control?.currentPage === 1) {
        setListData(getQuoteListData.ret_value);
      } else {
        setListData([...listData, ...getQuoteListData.ret_value]);
      }

      setModalities(getQuoteListData.modalities);
      setTimeout(() => updateIsLoadingStatus(false), 1000);

      let d = { ...getQuoteListData.pagination_control }
      d.currentPage = parseInt(d.currentPage);
      setPaginationControls(d);
      setCurrentPage(+getQuoteListData?.pagination_control?.currentPage);
      setTotalPages(getQuoteListData?.pagination_control?.totalPages);
    }
  }, [getQuoteListStatus]);

  useEffect(() => {
    updateIsLoadingStatus(getQuoteListLoading)
  }, [getQuoteListLoading]);

  const enumProductIcons = {
    52: "garantia",
    55: "garantia",
    56: "garantia",
    9004: "rcg"
  }

  function createModalIntegrationErrors(integrationErrors) {
    const errors = integrationErrors.filter((error) => error.service && error.userMessage && error.showInPopup);

    setDialog({
      visible: true,
      title: `Relatório do processo automático`,
      icon: 'exclamation',
      args: errors,
    })
  }


  return (
    <Layout title={ (permissions.CREATE_ENQUIRY || permissions.READ_ENQUIRY) && 'Cotações'}>
      <HasPermission permission={permissions.CREATE_ENQUIRY}>
        <NotesModal
          title={'Informações Adicionais'}
          textButtonConfirm={'Confirmar'}
          textButtonCancel={'Cancelar'}
          show={notesModal}
          setModalShow={setNotesModal}
          customCancelButton={[Colors.WHITE, Colors.PRIMARY1]}
          idOperation={idOperationSelected}
          idQuestion={1812}
          isMediationCompleted={isMediationFinished}
          textMediation='Cotação disponível, acesse a pasta de Documentos para realizar o download.'
          viewMode={true}
        />
        <DialogComponent icon={dialog.icon} size='60%' show={dialog.visible} setDialog={setDialog}>
          <ContentCard title={dialog.title} noBorder={true}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ width: "100%" }}>
                {dialog.args?.map(arg => {
                  return (
                    <p>
                      <span style={{ fontWeight: "bold" }}>{arg?.service}:&nbsp;</span>{arg?.userMessage}<br></br>
                      <span style={{ fontWeight: "bold" }}>Data:&nbsp;</span>{arg?.dateTime}
                    </p>
                  )
                })}
              </div>

              <Button
                third
                style={{ marginTop: '20px' }}
                onClick={() => setDialog({ visible: false, title: null, icon: null, args: null })}
              >
                Fechar
              </Button>
            </div>
          </ContentCard>
        </DialogComponent>
        <HasPermission permission={permissions.CREATE_ENQUIRY}>
          <p style={{ margin: '14px auto' }}>Nova Cotação:</p>
          <ContainerProducts>
            {permissions.CREATE_ENQUIRY && products.map(item => (
              <ItemProduct onClick={() => history.push(`create-enquiry/${item.value}`)}>
                <Icon name={enumProductIcons[item?.value]} />
                <TitleProducts> {item.label}</TitleProducts>
              </ItemProduct>
            ))}
          </ContainerProducts>
        </HasPermission>
        {/* fix stg-merge ref issue fitinsur/fitinsur-sompo#1975 */}
      </HasPermission>
      <HasPermission permission={permissions.READ_ENQUIRY}>
        <Content>
          <Formik
            initialValues={initialValues}
            onSubmit={(values) => handleFilter(values)}
            innerRef={formik}
          >
            {(formikProps) => (
              <Form>
                <ListHeader
                  idDomainList={318}
                  idApplication={675}
                  filterData={filterData}
                  setFilterData={setFilterData}
                  onHandleFilter={(resetFilter) => handleFilter(resetFilter)}
                  listNameSpace={'enquiry-filter-sompo'}
                  listUrl='/list'
                  optionsProduct={products}
                  optionsModalities={modalities}
                  optionsBroker={brokerList}
                  optionsStatus={optionsStatus}
                  optionsTypeInsurance={[
                    { label: 'Seguro Novo', value: 8926 },
                    { label: 'Renovação', value: 8927 }
                  ]}
                  optionsSla={[
                    { label: 'Cinza', value: 'gray' },
                    { label: 'Verde', value: 'green' },
                    { label: 'Amarelo', value: 'yellow' },
                    { label: 'Vermelho', value: 'red' }
                  ]}
                  exportList={() => exportList(location.search || undefined)}
                  availabelStatuses={[
                    1, 7, 4, 10, 8,
                    5, 2, 16, 19, 20, 406
                  ]}
                />
                <>
                  <ResponsiveTable onSortTable={handleSortList} formikRef={formik?.current} columns={columns} data={listData} />
                  {!listData.length && <ButtonContainer style={{ minHeight: '450px' }}>
                    <Text style={{ fontWeight: 'bold', color: Colors.GRAY[1], margin: 'auto', cursor: 'pointer', marginTop: '10px' }} onClick={() => { }}>{message || ''}</Text>
                  </ButtonContainer>}
                </>
              </Form>
            )}
          </Formik>
          <LoadContainer>
            {!listData || listData.length === 0 || currentPage === totalPages ? (
              <Button forth onClick={(e) => e.preventDefault()}>
                NÃO HÁ MAIS ITENS
              </Button>
            ) : (
              <Button forth onClick={() => setNextPage(paginationControls)}>
                + CARREGAR MAIS
              </Button>
            )}
          </LoadContainer>
        </Content>
      </HasPermission>
    </Layout>
  );
}
